import React from 'react';
import classNames from 'classnames';
import { FaInfoCircle, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import ReactTooltip from 'react-tooltip';
import { Auth, Storage } from 'aws-amplify';
import S3_CONFIG from '../../../config/s3.json'

import { FileUploadRing } from '../../Util/LoadingIcons'

let customPrefix = {
    public: 'public/',
    protected: 'protected/',
    private: 'jobs/*/'
}

/*
Args:
    classes: Classes for React CSS
    handleInputChange: Function which updates the state in the Form based on user inputs
    title: String;  The name displayed above the switch to the user
    name: String; The name of the variable referenced in the Form's state.  This variable is used
        both for setting the state in the form, but also for the folder structure in S3
    value: String; The name of the variable referenced in the Form's state
    tooltip: String; information which may help the user complete the form
*/

class FileUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentAuth: {},
            uploadFileError: false,
            uploadedFiles: [],
        };

        // Avoid setting the state after the component was unmounted
        // https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
        this._isMounted = false;

    }

    componentDidMount() {
        this._isMounted = true;
        this._isMounted && Auth.currentAuthenticatedUser().then(user => {
            this.setState({currentAuth: user.attributes});
            customPrefix.private = `${S3_CONFIG.PREFIX}/${this.state.currentAuth['custom:organization']}/`
        }).catch(err => console.log(err))

        this._isMounted && this.listUserData()
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    listUserData() {
        let options =  {
            customPrefix: customPrefix,
            level: 'private',
        }
        Storage.list(`data/${this.props.name}/`, options)
            .then(result => {
                // Use a map operation to split the objects key and just show the file name
                result.map(file => file.label = file.key.split('/').pop())
                this._isMounted && this.setState({uploadedFiles: [{key: 'NONE', label: 'None'}].concat(result)})
            }
            )
            .catch(err => console.log(err));
    }

    uploadFile(e) {
        let file = e.target.files[0];
        let options =  {
            customPrefix: customPrefix,
            level: 'private',
            contentType: file.type
        }

        this.setState({uploadFileError: 'uploading'})

        Storage.put(`data/${this.props.name}/${file.name}`, file, options)
            .then (result => {
                this._isMounted && this.setState({uploadFileError: 'noError'})
            })
            .catch(err => {
                this.setState({uploadFileError: 'error'})
            });
    }

    uploadFileIndicator() {
        if (this.state.uploadFileError === 'error'){
            return <FaTimesCircle style={{color:'red'}}/>
        } else if(this.state.uploadFileError === 'noError'){
            return <FaCheckCircle style={{color:'green'}}/>
        } else if(this.state.uploadFileError === 'uploading'){
            return <FileUploadRing/>
        } else {
            return null
        }
    }

    render(){
        return (
            <div className="form-input-container">
                <b> {this.props.title} File (optional)<FaInfoCircle data-tip data-for={this.props.name}/> </b>

                <ReactTooltip id={this.props.name} place="right" type="light" effect="solid">
                    {this.props.tooltip}
                </ReactTooltip>

                <div>
                    <TextField
                        className={classNames(this.props.classes.margin, this.props.classes.textField)}
                        select
                        style={{width: '194px'}}
                        label="Selected File"
                        name={this.props.name}
                        value={this.props.value}
                        onClick={() => this.listUserData()}
                        onChange={this.props.handleInputChange}>

                        {this.state.uploadedFiles.map(file => (
                            <MenuItem key={file.key+this.props.name} value={file.key}>
                                {file.label}
                            </MenuItem>
                        ))}
                    </TextField>

                    <Button
                        className={classNames(this.props.classes.margin, this.props.classes.textField)}
                        component="label"
                        size="small"
                        variant="outlined"
                    > Upload New File

                        <input type="file"
                               style={{ display: 'none' }}
                               name={this.props.name}
                               onChange={(e) => this.uploadFile(e)}
                        />
                    </Button> {this.uploadFileIndicator()}

                </div>
            </div>

        )
    }
}
export default FileUpload;
